import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UISupplierContext } from 'src/app/models/internal/uisuppliercontext';
import { AppGlobalDataService } from 'src/app/services/appglobaldata.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { Constants } from 'src/app/core/constants';
import { ProposalService } from 'src/app/services/proposal.service';
import { QueryExternalCommentUnReadDTO } from 'src/app/models/internal/query-external-comment-unread-dto';
import { DataService } from '../../services/data.service';
import { NGXLogger } from 'ngx-logger';
import UIHelper from '../../core/utility/ui-helper';
import { AppSettings } from 'src/app/app.settings';
import { StorageSettings } from 'src/app/utils/storage.settings';
import Helper from 'src/app/core/utility/helper';

@Component({
    selector: 'app-suppliercontext',
    templateUrl: './suppliercontext.component.html',
    styleUrls: ['./suppliercontext.component.scss'],
})
export class SuppliercontextComponent implements OnInit {
    public IsSupplier: boolean = false;
    // @Output() private supplierContextUpdated: EventEmitter<string> = new EventEmitter<string>();

    UISupplierContexts: UISupplierContext[];
    CurrentSupplierCode: string;
    UISupplierContextForm: FormGroup;
    locStorage = Constants.localStorageKeys;
    constructor(
        private appGlobalDataService: AppGlobalDataService,
        private dataService: DataService,
        private localstorageService: LocalstorageService,
        public appSettings: AppSettings,
        private logger: NGXLogger,
        private fb: FormBuilder,
        public storageSettings: StorageSettings
    ) {
        this.UISupplierContextForm = this.fb.group({
            currentUISupplierContextSupplierCode: [null],
        });
        UIHelper.updateLoggerConfig(appSettings, logger);
    }

    ngOnInit() {
        this.appGlobalDataService.UISupplierContexts.subscribe(data => {
            if (data != null) {
                this.UISupplierContexts = data;
            }
            if (this.UISupplierContexts && this.UISupplierContexts.length > 0) {
                this.setSupplierCode();
                // this.currentSupplierCode = this.UISupplierContexts[0].SupplierCode;
            }
        });

        this.appGlobalDataService.IsSupplier.subscribe(data => {
            if (data != null) {
                this.IsSupplier = data;
            }
        });
    }
    setSupplierCode(supplierCode?: string) {
        const locStorage = this.locStorage;
        let supCode = '';
        if (!supplierCode &&
            this.UISupplierContexts &&
            this.UISupplierContexts.length > 0) {
            supCode = this.UISupplierContexts[0].SupplierCode;
        } else {
            supCode = supplierCode;
        }
        this.UISupplierContextForm.controls[
            'currentUISupplierContextSupplierCode'
        ].setValue(supCode);
        this.localstorageService.store(locStorage.CurrentSupplierCode, supCode);
        // TMS-17419 Errors immediately after logging in. Consolidate user logging validation.
        this.appGlobalDataService.IsSupplier.subscribe((data) => {
            if (data && 
                this.IsSupplier &&                
                Helper.CheckSupplierLogin(this.storageSettings)) {
                this.refreshUnreadMessageCount(supCode);
            }
        });
        // this.appGlobalDataService.RefreshcurrentSupplierCode(supCode); // this goes in infinite loop redirecting to landingpage

    }
    refreshUnreadMessageCount(supplierCode: string) {
        this.logger.debug('Fetching unread message count for sup code = ' + supplierCode);
        if (supplierCode) {
            const queryExternalCommentUnReadDTO: QueryExternalCommentUnReadDTO = new QueryExternalCommentUnReadDTO();
            queryExternalCommentUnReadDTO.SupplierCode = supplierCode;
            this.dataService
      .getUnreadProposalExternalCommentCount(queryExternalCommentUnReadDTO)
      .subscribe((response: any) => {
        if (response != null) {
            this.appGlobalDataService.RefreshUnreadMessageCount(response.Data);
      }
  });

        }
    }
    setSupplierContext() {
        const locStorage = this.locStorage;
        this.UISupplierContexts = this.localstorageService.retrieve(
            locStorage.UISupplierContexts
        );
        this.CurrentSupplierCode = this.localstorageService.retrieve(
            locStorage.CurrentSupplierCode
        );
        if (this.UISupplierContexts) {
            this.setSupplierCode(this.CurrentSupplierCode);
        }
    }
    UISupplierContextChanged(SupplierCode: string) {
        const locStorage = this.locStorage;
        this.localstorageService.store(
            locStorage.CurrentSupplierCode,
            SupplierCode
        );
        this.setSupplierContext();
        this.appGlobalDataService.RefreshcurrentSupplierCode(SupplierCode);
    }
}
